import { render } from "./FilterableSelect.vue?vue&type=template&id=3fd96884&scoped=true&lang=pug"
import script from "./FilterableSelect.vue?vue&type=script&lang=ts"
export * from "./FilterableSelect.vue?vue&type=script&lang=ts"

import "./FilterableSelect.vue?vue&type=style&index=0&id=3fd96884&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fd96884"

export default script